// extracted by mini-css-extract-plugin
module.exports = {"summaryFilter":"summaryFilter__RRad+"};